import pkg from "../../package.json";

/**
 * Build metadata injected by Jenkins at compile time via CRA REACT_APP_* env vars.
 *
 * Jenkins environment block sets:
 *   REACT_APP_APP_VERSION  = RELEASE_VERSION  (e.g. "1.0.42")
 *   REACT_APP_BUILD_NUMBER = BUILD_NUMBER      (e.g. "42")
 *
 * Falls back to package.json version / "local" when running outside CI (npm start).
 */
export const APP_VERSION: string =
  process.env.REACT_APP_APP_VERSION || pkg.version;

export const BUILD_NUMBER: string =
  process.env.REACT_APP_BUILD_NUMBER || "local";
